import Workout from "../../common/Workout/Workout.js";
import "./style.css";
import BigDaddyFitnessHeader from "./BigDaddyFitnessHeader.js";

import jsonDataEn from "./data-en.json";
import jsonDataFr from "./data-fr.json";
import { useContext } from "react";
import LanguageContext from "../../../context/LanguageContext";

const FlxdeckWorkout = () => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data : jsonDataFr.data;
  return (
    <div className="bigdaddyfitness">
      <BigDaddyFitnessHeader />
      <Workout gymName="bigdaddyfitness" footer={data.footerTextLine1} />
    </div>
  );
};

export default FlxdeckWorkout;
